import React from 'react'

function LoadingPage() {
    return (
        <div className="w-full flex flex-col items-center justify-center min-h-screen bg-gradient-radial">

            {/* <!-- Blur Logo Box --> */}
            <div className="flex flex-col items-center backdrop-blur-xl bg-gradient-radial bg-black p-16 rounded-2xl shadow-lg">
                <div className="flex flex-col items-center mb-10">
                    <img
                        className="md:w-[10rem] w-[10rem] h-auto"
                        src="/assets/FWPI-logo.png"
                        alt="FWPI Logo"
                    />
                </div>
                {/* <!-- Smooth Ring Loader --> */}
                <div className="relative mb-1">
                    <div className="h-16 w-16 rounded-full border-[5px] border-gray-600 border-t-white animate-spin"></div>
                </div>

                <p className="mt-6 text-gray-700 text-base font-urbanist font-semibold">Please wait, loading your content…</p>
            </div>

        </div>

    )
}

export { LoadingPage }